import React from 'react';
import { Loader2 } from 'lucide-react';

interface LazyLoadingFallbackProps {
  message?: string;
  className?: string;
}

const LazyLoadingFallback: React.FC<LazyLoadingFallbackProps> = ({ 
  message = "Loading...", 
  className = "flex items-center justify-center min-h-[200px]" 
}) => {
  return (
    <div className={className}>
      <div className="flex flex-col items-center space-y-2">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};

export default LazyLoadingFallback;